export default "__VITE_ASSET__B4$l2dzw__"